import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { Hotel } from '../classes/hotel';
import { LoginService } from '../login/login.service';
import { environment } from '../../environments/environment';

@Injectable( {
    providedIn: 'root'
} )
export class HotelService {

    constructor( private http: HttpClient, private loginService: LoginService ) { }

    getHotel(): Observable<any> {
        const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.loginService.getToken()}` } ) };
        
        return this.http.get<Object>( environment.apiGethotel , httpOptions )
            .pipe(
            tap( _ => console.log( 'fetched hotel' ) ),
            catchError( this.handleError( 'getHotel', null ) )
            );
    }

    updateHotel( hotel: Hotel ): Observable<any> {
        const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json' } ) };
        return this.http.post(
            environment.apiUpdatehotel,
            JSON.stringify( {
                hotel: hotel
            } ), httpOptions )
            .pipe(
            tap( _ => console.log( `updated Hotel hotel=${hotel.hotel}` ) ),
            catchError( this.handleError( 'updateHotel', null ) )
            );
        ;
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>( operation = 'operation', result?: T ) {
        return ( error: any ): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error( error ); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of( result as T );
        };
    }
}
